import React, { useContext, useState, useEffect, useRef } from "react";
import { styled, alpha, useTheme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, Drawer, IconButton, Toolbar, Divider, Typography, Button, InputBase, Badge, MenuItem, Menu, List, ListItem, ListItemButton, ListItemText, useMediaQuery, Grid } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import { AppContext } from "../components/AppProvider";
import { AuthContext, AuthProvider, AuthRoutes } from "../components/Auth";
import { NavLink, useLocation } from "react-router-dom";
import { getAuth } from "firebase/auth";
import ResponsiveAppBar from "../components/ResponsiveAppBar";

export const AppTemplate = (props) => {
    const navigate = useNavigate();
    const auth = getAuth();
    const { config } = useContext(AppContext);
    const pathnames = config.pathnames;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <>
        <CssBaseline />
        <ResponsiveAppBar />
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Box component="main" sx={{
              flexGrow: 1,
              paddingTop: isMobile ? theme.spacing(7) : theme.spacing(8),
              backgroundColor: (theme) =>
                  theme.palette.mode === 'light'
                  ? theme.palette.grey[100]
                  : theme.palette.grey[900],
              paddingBottom: theme.spacing(2) // optional spacing from footer
            }}>
              <Outlet />
            </Box>
            <Box component="footer" sx={{
                backgroundColor: theme.palette.background.paper,
                textAlign: 'center',
                padding: theme.spacing(2),
                borderTop: `1px solid ${theme.palette.divider}`
                }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <NavLink to={pathnames.About} style={{ textDecoration: 'none', color: theme.palette.text.secondary }}>
                    About
                    </NavLink>
                    <NavLink to={pathnames.PrivacyPolicy} style={{ textDecoration: 'none', color: theme.palette.text.secondary }}>
                    Privacy Policy
                    </NavLink>
                    <NavLink to={pathnames.TermsOfService} style={{ textDecoration: 'none', color: theme.palette.text.secondary }}>
                    Terms of Service
                    </NavLink>
                    <NavLink to="/contact" style={{ textDecoration: 'none', color: theme.palette.text.secondary }}>
                    Contact
                    </NavLink>
                    <NavLink to="/ios-app" style={{ textDecoration: 'none', color: theme.palette.text.secondary }}>
                    iOS App
                    </NavLink>
                </Box>
                <Box sx={{ mt: 2, mb: 2 }}>
                    <NavLink to="https://apps.apple.com/app/ggc/id6748268912" style={{ textDecoration: 'none', color: theme.palette.text.secondary }}>
                    <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/2560px-Download_on_the_App_Store_Badge.svg.png"
                        alt="Download on the App Store"
                        style={{ height: 30 }}
                    />
                    </NavLink>
                </Box>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                    © {new Date().getFullYear()} GGC Live. All rights reserved.
                </Typography>
            </Box>
        </Box>
        </>
    )
}
